// Shared wordmark. Renders "Cann" + a real lowercase i (with natural tittle) + "Comply".
// The i is painted in champagne and slightly emphasised so the tittle reads clearly.
export default function BrandName({
  className = "",
  size = "inherit",
  tone = "inherit",
  dot = "#D4A65A",
}) {
  return (
    <span
      className={`brandname ${className}`}
      style={{ color: tone, fontSize: size, whiteSpace: "nowrap" }}
      aria-label="CanniComply"
    >
      Cann<span
        style={{
          color: dot,
          fontWeight: 700,
          fontStyle: "normal",
          letterSpacing: "0.02em",
          margin: "0 0.02em",
        }}
      >i</span>Comply
    </span>
  );
}
